import { filterTabEnterArrowsFromAutocompleteExperimental } from '@gonfalon/dogfood-flags/dogfood-flags';
import type { AutocompleteProps } from '@launchpad-ui/components';
import { Autocomplete as LaunchpadAutocomplete } from '@launchpad-ui/components';

/**
 * A wrapped version of the Launchpad Autocomplete that prevents event leakage
 * by stopping propagation of keyboard events originating from the input element.
 *
 * This allows internal interactions between the input and listbox (managed by
 * react-aria components) to proceed normally while preventing those key events
 * from bubbling out to ancestor components (e.g., a global CommandBar).
 */
export function Autocomplete(props: AutocompleteProps) {
  return (
    <div
      style={{ display: 'contents' }}
      ref={(ref) => {
        const inputEl = ref?.querySelector('input');
        if (inputEl instanceof HTMLInputElement && typeof inputEl.onkeydown !== 'function') {
          const allowKeys = ['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'Enter', 'Tab', 'Escape'];

          inputEl.onkeydown = (e: KeyboardEvent) => {
            if (allowKeys.includes(e.key) && filterTabEnterArrowsFromAutocompleteExperimental()) {
              return;
            }
            e.stopPropagation();
          };
        }
      }}
    >
      <LaunchpadAutocomplete {...props} />
    </div>
  );
}
